import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { API_BASE_URL } from "../../environment";

const MySwal = withReactContent(Swal);

interface LocationState {
  email?: string;
}

const EmailVerification = () => {
  const route = all_routes;

  // grab the raw location object…
  const location = useLocation();
  // …and assert its state shape
  const state = (location.state as LocationState) ?? {};
  const email = state.email ?? "";

  const [isResending, setIsResending] = useState(false);

  const handleResendVerification = async () => {
    if (!email) {
      MySwal.fire({
        icon: "error",
        title: "Email Not Found",
        text: "Email address is not available. Please go back to registration.",
        showConfirmButton: true,
      });
      return;
    }

    setIsResending(true);

    try {
      const res = await fetch(`${API_BASE_URL}/user/resend-verification/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) throw new Error("Failed to resend verification email");

      const data = await res.json();

      MySwal.fire({
        icon: "success",
        title: "Verification Email Sent",
        text: data.message || "Verification email has been sent successfully. Please check your inbox.",
        showConfirmButton: true,
      });
    } catch (err) {
      console.error(err);
      MySwal.fire({
        icon: "error",
        title: "Failed to Send Verification Email",
        text: "Could not send verification email. Please try again.",
        showConfirmButton: true,
      });
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="account-content">
      <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-04">
        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
          <form>
            <div className="mx-auto mw-450">
              <div className="text-center mb-4">
                <ImageWithBasePath
                  src="assets/img/Logo.png"
                  className="img-fluid"
                  alt="Logo"
                />
              </div>
              <div className="text-center mb-3">
                <span className="avatar avatar-xl rounded-circle bg-success mb-4">
                  <i className="ti ti-check fs-26" />
                </span>
                <h4 className="mb-2 fs-20">Verify Your Email</h4>
                <p className="mb-3">
                  We've sent a link to <strong>{email}</strong><br />
                  Please follow the link to continue.
                </p>
                <h6>
                  Didn't receive it?{" "}
                  <Link
                    to="#"
                    className="text-purple link-hover"
                    onClick={(e) => {
                      e.preventDefault();
                      handleResendVerification();
                    }}
                    style={{
                      pointerEvents: isResending ? 'none' : 'auto',
                      opacity: isResending ? 0.6 : 1
                    }}
                  >
                    {isResending ? 'Sending...' : 'Resend Link'}
                  </Link>
                </h6>
              </div>
              <div className="mb-3">
                <Link
                  to={route.login}
                  className="btn btn-primary w-100"
                >
                  Go Back To Login
                </Link>
              </div>
              <div className="text-center">
                <p className="fw-medium text-gray">Copyright © {new Date().getFullYear()} - Cloudee Sales CRM. All rights reserved.</p>
              </div>
            </div>
          </form>
        </div>
        <div className="w-50 vh-100 d-none d-md-block bg-gray-100" />
      </div>
    </div>
  );
};

export default EmailVerification;
